import { render } from "./AddJob.vue?vue&type=template&id=113f645d&scoped=true"
import script from "./AddJob.vue?vue&type=script&lang=js"
export * from "./AddJob.vue?vue&type=script&lang=js"

import "./AddJob.vue?vue&type=style&index=0&id=113f645d&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113f645d"]])

export default __exports__